import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { IMG } from "@/lib/images";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { EditorialMarquee } from "@/components/Marquee";
import { BookConsultation } from "@/components/BookConsultation";
import { SEO } from "@/components/SEO";
import { pageSEO } from "@/lib/seo";
import { useLang } from "@/i18n/LanguageContext";

export default function Mariages() {
  const { c, lang } = useLang();
  const m = c.pages.mariages;
  return (
    <div data-testid="mariages-page">
      <SEO {...pageSEO("mariages", lang)} path="/mariages" lang={lang} image={IMG.wedding} />
      <PageHeader eyebrow={m.eyebrow} lines={m.hLines} title="Mariages" subtitle={m.subtitle} image={IMG.wedding} />
      <section className="py-24 lg:py-32 bg-olime-bg">
        <div className="container-olime grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-24 items-center">
          <div>
            <Reveal><span className="eyebrow">{m.secEyebrow}</span>
              <h2 className="font-serif text-4xl md:text-5xl tracking-tight mt-4">{m.secTitle}</h2></Reveal>
            <Reveal delay={0.15}>
              <p className="mt-6 text-olime-muted leading-relaxed">{m.secText}</p>
              <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
                {m.offers.map((o) => <li key={o} className="flex items-center gap-3 text-olime-ink"><Check size={15} className="text-olime-stone" /> {o}</li>)}
              </ul>
              <div className="mt-10 flex flex-wrap gap-4">
                <Link to="/contact?type=Wedding Design#form" data-testid="mariages-cta" className="btn-ink">{m.cta} <ArrowRight size={14} /></Link>
                <BookConsultation variant="outline" testId="mariages-book-cta" />
              </div>
            </Reveal>
          </div>
          <Reveal><img src={IMG.portfolio3} alt="Mariage" className="w-full aspect-[4/5] object-cover" /></Reveal>
        </div>
      </section>
      <EditorialMarquee words={m.marquee} />
    </div>
  );
}
